export default "__VITE_ASSET__DxCUS57X__"